export function logError(error, errorInfo = null) {
  if (errorInfo) {
    console.log(error, errorInfo);
  } else {
    console.log(error);
  }
}
